import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children }) => (
  <p className="font-body text-xs uppercase tracking-[0.35em] text-gold mb-5 flex items-center gap-3">
    <span className="h-px w-8 bg-gold/60 inline-block" aria-hidden="true" />
    {children}
  </p>
);
